export const initialRendererState = {
    height: 300,
    width: 800,
    variation: undefined
}
